const config = {
  apiUrl: 'http://staging-pos.sunbit.in',
};

export default config;




// WEBPACK FOOTER //
// ./src/config/oregon-local.js